import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IJobPayment extends IModel {
	accountingId?: string;
	amount?: number;
	description?: string;
	type?: string;
	transactionMethod?: string;
	transactionReference?: string;
	jobCostKey?: string;
	changeOrderKey?: string;
	appliedToContract?: boolean;
	systemGenerated?: boolean;
}

const jobPaymentFactory = modelFactory.createFactory<IJobPayment>('JobPayment', _.assign({}, model, {
	accountingId: {
		setFilters: valueFilters.clean
	},
	amount: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: [validator.required(), validator.not(0)]
	},
	description: {},
	type: {
		rules: validator.required()
	},
	transactionMethod: {
		rules: validator.required()
	},
	transactionReference: {
		rules: [
			(value, target) => {
				if (['account', 'cash'].indexOf(target.transactionMethod) === -1) {
					return validator.required()(value, target, 'Transaction Reference');
				}
			}
		]
	},
	jobCostKey: {
		setFilters: valueFilters.clean
	},
	changeOrderKey: {
		setFilters: valueFilters.clean
	},
	appliedToContract: {
		setFilters: valueFilters.toBoolean
	},
	systemGenerated: {
		setFilters: valueFilters.toBoolean
	}
}));

export default jobPaymentFactory;